// Imports
import AmazonCognitoIdentity from "amazon-cognito-identity-js/dist/amazon-cognito-identity.js";

// Static variables
const _config = {
    cognito: {
        userPoolId: "us-east-1_xb3QgOK1G",
        userPoolClientId: "5k2g9eol99ctgb969844e2jl8l",
        region: "us-east-1",
    },
    api: {
        invokeUrl:
            "https://8w0x72uzr5.execute-api.us-east-1.amazonaws.com/prod"
    },
};
var userPool;

export function createUserPool() {
    var poolData = {
        UserPoolId: _config.cognito.userPoolId,
        ClientId: _config.cognito.userPoolClientId,
    };
    userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    if (typeof AWSCognito !== "undefined") {
        AWSCognito.config.region = _config.cognito.region;
    }
    return userPool;
}

export function constructCognitoUser(email) {
    var userName = email;
    var cognitoUser = new AmazonCognitoIdentity.CognitoUser({
        Username: userName,
        Pool: userPool,
    });
    return cognitoUser;
}

export function signOutCognitoUser() {
    var user = userPool.getCurrentUser();
    if (user) {
        user.signOut();
    }
}

export async function fetchCurrentAuthToken(resolve, reject) {
    var user = userPool.getCurrentUser();
    if (user) {
        var onCallback = function sessionCallback(err, session) {
            if (err) {
                console.log("Auth error: " + err.message);
                reject(err);
            } else if (!session.isValid()) {
                resolve(null);
            } else {
                resolve(session.getIdToken().getJwtToken());
            }
        }
        user.getSession(onCallback);
    } else {
        resolve(null);
    }
}

export function formRequestAction(action, payload, authToken) {
    /** The request has a JSON body: {action: string, user: string, payload: {...}} }
        Payloads for actions are:
            - Read-Seed: payload = { wpn_id = string }
            - Read-Utility: payload = { wpn_id = string }
            - Print: payload = { items: [ {} ] }
            - Export: payload = { items: [ {} ] }
            - Modify: payload = { items: [ {} ] }
            - Message: payload = { items: [ {} ]}
    */
    var user = userPool.getCurrentUser();
    var url = _config.api.invokeUrl + '/get-seed';
    var bodyData = {
        action: action,
        user: user.username,
        payload: payload
    };
    const initData = requestInitData(bodyData, 'application/json', authToken);
    return { url: url, initData: initData }
}

export function getUserEmail(attributes) {
    return (attributes != undefined) ? attributes['email'] : "";
}

export function getUserWpnId(attributes) {
    return (attributes != undefined) ? attributes['custom:wpn_id'] : "";
}

export function getUserAttributes(user) {
    const currentUser = (user) ? user : userPool.getCurrentUser();
    return new Promise((resolve, reject) => {
        currentUser.getUserAttributes(function(err, attributes) {
            if (err) {
                reject(err);
            } else {
                const attrs = attributes.reduce((acc, attribute) => {
                    acc[attribute.getName()] = attribute.getValue();
                    return acc;
                }, {});
                resolve(attrs);
            }
        });
    });
}

function requestInitData(bodyData, contentType, authToken) {
    const headers = {
        Authorization: authToken,
        'Content-Type': contentType
    };
    return {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: headers,
        body: JSON.stringify(bodyData),
    };
}
